export const Skeleton = ({ width, height }: { width: string; height: string }) => (
  <div className={`animate-pulse bg-gray-100 ${height} ${width} rounded`}></div>
)
